"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyUpPropsSDKFactory = void 0;
const corvidEvents_1 = require("../corvidEvents");
const keyUpPropsSDKFactory = api => {
    return {
        onKeyUp: handler => corvidEvents_1.registerCorvidEvent('onKeyUp', api, handler),
    };
};
exports.keyUpPropsSDKFactory = keyUpPropsSDKFactory;
//# sourceMappingURL=keyUpPropsSDKFactory.js.map